import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgBackground = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 24 24",
	fill: "none",
	stroke: "currentColor",
	strokeWidth: 2,
	strokeLinecap: "round",
	strokeLinejoin: "round",
	className: "lucide lucide-wallpaper-icon lucide-wallpaper",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", { d: "M12 17v4" }),
		/* @__PURE__ */ _jsx("path", { d: "M8 21h8" }),
		/* @__PURE__ */ _jsx("path", { d: "m9 17 6.1-6.1a2 2 0 0 1 2.81.01L22 15" }),
		/* @__PURE__ */ _jsx("circle", {
			cx: 8,
			cy: 9,
			r: 2
		}),
		/* @__PURE__ */ _jsx("rect", {
			x: 2,
			y: 3,
			width: 20,
			height: 14,
			rx: 2
		})
	]
});
export default SvgBackground;
